import { render, staticRenderFns } from "./EditDiscountAmount.vue?vue&type=template&id=5f34872d&scoped=true&"
import script from "./EditDiscountAmount.vue?vue&type=script&lang=js&"
export * from "./EditDiscountAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f34872d",
  null
  
)

export default component.exports